enum TransactionType {
  STX20Protocol = 'STX20Protocol',
  STXSDomain = 'STXSDomain',
  STXSMap = 'STXSMap',
}

interface IParsedSTX20Transaction {
  type: ProtocolTransactionType;
  ticker: string;
  value?: string;
  totalSupply?: string;
  mintLimit?: string;
}

enum ProtocolTransactionType {
  Deploy = 'd',
  Transfer = 't',
  Mint = 'm',
}
const parseSTX20protocolTransaction = (str: string): IParsedSTX20Transaction | null => {
  if (str.length === 0) {
    return null;
  }
  let pattern;
  const firstChar = str.charAt(0);

  if (firstChar === ProtocolTransactionType.Transfer) {
    pattern = /^(\w)([A-Za-z]{3,10})(\d+)$/;
  } else {
    return null;
  }

  const match = str.match(pattern);

  if (!match) {
    return null;
  }

  return {
    mintLimit: undefined,
    totalSupply: undefined,
    type: match[1] as ProtocolTransactionType,
    ticker: match[2].toUpperCase(),
    value: parseInt(match[3], 10).toString(10),
  };
};

function parseDomainName(str: string): string | null {
  if (str.length === 0) {
    return null;
  }
  const regex = /^([A-Za-z0-9_-]{0,25})\.stxs$/;

  const match = str.match(regex);

  return match ? match[0] : null;
}

function parseBitmapBlock(str: string): string | null {
  if (str.length === 0) {
    return null;
  }
  const pattern = /^(\d{1,25})\.stxsmap$/;
  const match = str.match(pattern);

  return match ? match[1] : null;
}

function isValidInt(str: string) {
  const num = Number(str);

  return Number.isInteger(num) && String(num) === str;
}

export function getEventFromTransferMemo(str: string) {
  const protocolEvent = parseSTX20protocolTransaction(str);
  if (protocolEvent) {
    return {
      type: TransactionType.STX20Protocol,
      event: protocolEvent,
    };
  }
  const domainName = parseDomainName(str);
  if (domainName) {
    return {
      type: TransactionType.STXSDomain,
      event: domainName,
    };
  }
  const bitmapBlock = parseBitmapBlock(str);
  if (isValidInt(bitmapBlock || '')) {
    return {
      type: TransactionType.STXSMap,
      event: bitmapBlock,
    };
  }
}
